import {
  Link as MUILink,
  LinkProps as MUILinkProps,
  Typography,
  TypographyProps
} from '@mui/material'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps
} from 'react-router-dom'
import { LinkStyleType, LinkType, TextOrTranslation } from '.'

type CommonLinkProps = Omit<MUILinkProps, 'color' | 'underline'>

export type BasicLinkProps = CommonLinkProps & {
  type: LinkType.BASIC
}

export type RoutedLinkProps = CommonLinkProps &
  Pick<RouterLinkProps, 'to'> & {
    type: LinkType.ROUTED
  }

type LinkProps = (BasicLinkProps | RoutedLinkProps) & {
  isUnderlined?: boolean
  translationId?: string
}

export const Link = ({
  children,
  isUnderlined = false,
  translationId,
  type,
  ...rest
}: LinkProps) => {
  const typeProps =
    type === LinkType.ROUTED ? { component: RouterLink } : undefined
  const linkProps = {
    ...rest,
    ...typeProps
  }
  return (
    <MUILink
      color="secondary"
      underline={isUnderlined ? 'always' : 'none'}
      {...linkProps}
    >
      <TextOrTranslation text={children} translationId={translationId} />
    </MUILink>
  )
}

type StyledLinkProps = LinkProps & {
  linkStyleType?: LinkStyleType
  typographyProps?: TypographyProps
}

export const StyledLink = ({
  children,
  linkStyleType = LinkStyleType.NORMAL,
  typographyProps,
  ...rest
}: StyledLinkProps) => {
  return (
    <Typography
      fontWeight={linkStyleType === LinkStyleType.IMPORTANT ? 'bold' : 'normal'}
      {...typographyProps}
    >
      <Link {...rest}>{children}</Link>
    </Typography>
  )
}
